import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { environment } from '../../environments/environment';
import { LOCALE_PREFIX } from '../configs';

@Component({
  selector: 'girko-overlay',
  template: `
    <div class="content">
      <h4>{{ text }}</h4>
      <a href="{{ urlPrefix }}{{ localePrefix }}/advertising/" class="btn btn-success">{{ 'Детальніше' | translate }}</a>
    </div>
  `,
  styles: [
    `
      :host {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.85);
        z-index: 2;
      }

      .content {
        padding: 100px 30px;
        text-align: center;
      }

      h4 {
        color: #d8d8d8;
        font-weight: 300;
        line-height: 1.6;
      }

      .btn {
        margin-top: 15px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverlayComponent {
  @Input() text: string;
  urlPrefix = environment.urlPrefix;
  localePrefix = LOCALE_PREFIX;
}
